export default [
    {
        questionType: 1,
        question: "您的性别？",
        allAnswers: [
            {
                answerType: 1,
                answerText: "男"
            },
            {
                answerType: 1,
                answerText: "女"
            }
        ],
        selectedIndex: [],
        answer: ""
    },
    {
        questionType: 1,
        question: "您的年龄？",
        allAnswers: [
            {
                answerType: 1,
                answerText: "18岁以下"
            },
            {
                answerType: 1,
                answerText: "18-30岁"
            },
            {
                answerType: 1,
                answerText: "31-50岁"
            },
            {
                answerType: 1,
                answerText: "51岁以上"
            }
        ],
        selectedIndex: [],
        answer: ""
    },
    {
        questionType: 1,
        question: "您从事的职业？",
        allAnswers: [
            {
                answerType: 1,
                answerText: "白领类（办公室、技术、设计）"
            },
            {
                answerType: 1,
                answerText: "教育类（教师、培训）"
            },
            {
                answerType: 1,
                answerText: "公职类（公务、国家、政府）"
            },
            {
                answerType: 1,
                answerText: "贸易类（销售、市场、商场）"
            },
            {
                answerType: 1,
                answerText: "蓝领类（建设、匠人、普通工人）"
            },
            {
                answerType: 1,
                answerText: "管理类（领导者、经理、干部）"
            },
            {
                answerType: 1,
                answerText: "其它"
            }
        ],
        selectedIndex: [],
        answer: ""
    },
    {
        questionType: 1,
        question: "您每月的收入大概是？",
        allAnswers: [
            {
                answerType: 1,
                answerText: "2000元以下"
            },
            {
                answerType: 1,
                answerText: "2000-4999"
            },
            {
                answerType: 1,
                answerText: "5000-8999"
            },
            {
                answerType: 1,
                answerText: "9000-12999"
            },
            {
                answerType: 1,
                answerText: "13000以上"
            }
        ],
        selectedIndex: [],
        answer: ""
    },
    {
        questionType: 1,
        question: "您还使用过其它类似微码的功能型应用吗？",
        allAnswers: [
            {
                answerType: 1,
                answerText: "没有"
            },
            {
                answerType: 2,
                answerText: "有"
            }
        ],
        selectedIndex: [],
        answer: ""
    },
    {
        questionType: 2,
        question: "您认为创翼微码目前存在哪些问题？",
        allAnswers: [
            {
                answerType: 1,
                answerText: "界面混乱不友好"
            },
            {
                answerType: 1,
                answerText: "流程繁琐复杂"
            },
            {
                answerType: 1,
                answerText: "运行速度缓慢"
            },
            {
                answerType: 1,
                answerText: "程序错误崩溃"
            },
            {
                answerType: 1,
                answerText: "功能单一内容单调"
            },
            {
                answerType: 2,
                answerText: "其它"
            }
        ],
        selectedIndex: [],
        answer: ""
    },
    {
        questionType: 1,
        question: "您对创翼微码的满意度是？",
        allAnswers: [
            {
                answerType: 1,
                answerText: "非常不满意"
            },
            {
                answerType: 1,
                answerText: "一般"
            },
            {
                answerType: 1,
                answerText: "比较满意"
            },
            {
                answerType: 1,
                answerText: "非常满意"
            }
        ],
        selectedIndex: [],
        answer: ""
    },
    {
        questionType: 1,
        question: "您认为创翼微码需要新增其它功能吗？",
        allAnswers: [
            {
                answerType: 1,
                answerText: "不用新增功能"
            },
            {
                answerType: 2,
                answerText: "需要新增功能"
            }
        ],
        selectedIndex: [],
        answer: ""
    },
];
